import { convertedDate } from "@/lib/Util";

export function convertDate(value: string) {
  if (value) {
    return convertedDate(value);
  }
  return;
}